import Accordion from 'react-bootstrap/Accordion';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const AccordionDescriptions = () => {
    return (
        <Accordion className="accordion-base">
            <Accordion.Item eventKey="0">
                <Accordion.Header>Wo finde ich meine Webadresse</Accordion.Header>
                <Accordion.Body className="pb-0 pt-1">
                    <Container>
                        <Row>
                            <Col className="mt-3" md={4} sm={4}>
                                <div className="d-flex justify-content-center">
                                    <img style={{ display: 'block', width: '100%', maxWidth: '220px' }} src="/wp-content/themes/gutentag/assets/img/domainname_illustration.png"/>
                                </div>
                            </Col>
                            <Col className="mt-3" style={{ fontSize: '14px' }} md={8} sm={8}>
                                Sie finden die Webadresse auf Ihrer QR-Karte vom Fotografen. Alternativ können Sie die Webadresse in einer E-Mail vom Fotografen nachsehen oder ihn direkt kontaktieren.
                            </Col>
                        </Row>
                    </Container>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
}

export default AccordionDescriptions;
